import React from "react";
import Button from "../../common/button/button";
import TableInCell from "../../common/table/tableInCell";
import Grid from "../../common/layout/grid";
import Row from "../../common/layout/row";

export function SaldosUnidadeConsumidora(props) {
    const borderColor = props.borderColor || "#222";
    const descricaoAdicional = props.buttonWidth ? "Saldo " : "";
    const { exibirCondicaoAdversa, corSaldo, corTabelaSaldo, indicadorSaldo, calculoAmpliacao } = props.getDadosItem(props.item);


    return (
        <div
            style={{
                display: "flex",
                flexDirection: props.sideTableButton ? "row-reverse" : "column",
                alignItems: "center",
                gap: 5,
                padding: props.sideTableButton ? 5 : 0,
                marginBottom: props.sideTableButton ? 5 : 0,
                backgroundColor: props.sideTableButton ? "#008ca8" : null,
                borderRadius: props.buttonBorderRadius || null,
            }}
        >
            {props.item.unidade_geradora || props.item.unidade_remota ? (
                <div>
                    <Button
                        style={{
                            margin: props.sideTableButton ? 0 : "5px 0px 0px 0px",
                            padding: 0,
                            height: props.buttonHeight || 20,
                            width: props.buttonWidth || 100,
                            background: props.buttonBackground,
                            borderRadius: props.buttonBorderRadius || null,
                        }}
                        type="info"
                        title="Visualizar gráfico de saldo de geração (kWh)"
                        text={
                            <div style={{ fontSize: props.sideTableButton ? "1rem" : "0.8rem" }}>
                                <i className="fas fa-chart-bar mr-2"></i>Saldos
                            </div>
                        }
                        event={() => props.setModoTela("graficoGeracaoSaldo", props.item)}
                    />
                </div>
            ) : null}
            {[1, 4].includes(props.item.id_grupo_faturamento) ? (
                <TableInCell
                    borderRadius={props.buttonBorderRadius || 0}
                    backgroundColor={corTabelaSaldo}
                    borderColor={borderColor}
                    width={props.buttonWidth || 100}
                    height={props.sideTableButton ? props.buttonHeight || 50 : 50}
                    lista={[
                        {
                            cabecalho: <div style={{ color: corSaldo }}>{descricaoAdicional} P </div>,
                            valor: (
                                <div style={{ color: corSaldo }}>
                                    {" "}
                                    {props.item.unidade_geradora || props.item.unidade_remota ? " " + Math.round(props.item.saldo_geracao_ponta || 0) : " - "}{" "}
                                </div>
                            ),
                        },
                        {
                            cabecalho: <div style={{ color: corSaldo }}>{descricaoAdicional} FP </div>,
                            valor: (
                                <div style={{ color: corSaldo }}>
                                    {" "}
                                    {props.item.unidade_geradora || props.item.unidade_remota ? " " + Math.round(props.item.saldo_geracao_fora_ponta || 0) : " - "}{" "}
                                </div>
                            ),
                        },
                        {
                            cabecalho: <div style={{ color: corSaldo }}>{descricaoAdicional} Total </div>,
                            valor: (
                                <div style={{ color: corSaldo }}>
                                    {props.item.unidade_geradora || props.item.unidade_remota ? (
                                        <>
                                            <span style={{ visibility: "hidden" }}>{indicadorSaldo}</span>
                                            <span>{Math.round(props.item.saldo_geracao || 0)}</span>
                                            {indicadorSaldo}
                                        </>
                                    ) : (
                                        " - "
                                    )}
                                </div>
                            ),
                        },
                    ]}
                />
            ) : (
                <div
                    style={{
                        color: corSaldo,
                        backgroundColor: corTabelaSaldo,
                        border: `1px solid ${borderColor}`,
                        height: props.buttonHeight || 20,
                        width: props.buttonWidth || 100,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: props.buttonBorderRadius || 0,
                    }}
                >
                    {props.item.unidade_geradora || props.item.unidade_remota ? (
                        <>
                            <span style={{ visibility: "hidden" }}>{indicadorSaldo}</span>
                            <span>
                                {descricaoAdicional ? `${descricaoAdicional}: ` : ""}
                                {Math.round(props.item.saldo_geracao || 0)}
                            </span>
                            {indicadorSaldo}
                        </>
                    ) : (
                        " - "
                    )}
                </div>
            )}
        </div>
    );
}
